import axios from "axios"
import { referralsUrl } from "../../config/microservicesUrls"

const api_url = referralsUrl()

async function referralAxiosPut(jwt, endpoint, data) {
  const axiosObj = axios.create()

  const requestConfig = {
    headers: {
      Authorization: "Bearer " + jwt,
    },
  }

  const x = await axiosObj
    .put(`${api_url}/${endpoint}`, data, requestConfig)
    .then((responseBody) => {
      return responseBody.data
    })

  return x
}

async function referralAxiosPost(jwt, endpoint, data) {
  const axiosObj = axios.create()

  const requestConfig = {
    headers: {
      Authorization: "Bearer " + jwt,
      "Content-Type": "application/json",
    },
  }

  const x = await axiosObj
    .post(`${api_url}/${endpoint}`, data, requestConfig)
    .then((responseBody) => {
      return responseBody.data
    })

  return x
}

async function referralAxiosGet(jwt, endpoint) {
  const axiosObj = axios.create()

  const requestConfig = {
    headers: {
      Authorization: "Bearer " + jwt,
    },
  }

  const x = await axiosObj
    .get(`${api_url}/${endpoint}`, requestConfig)
    .then((responseBody) => {
      return responseBody.data
    })

  return x
}

export async function refApiReferralsGet(jwt) {
  return await referralAxiosGet(jwt, "Referrals")
}

export async function refApiLocationTypesGet(jwt) {
  return await referralAxiosGet(jwt, "Options/ServiceDeliveryLocationRoleTypes")
}

export async function refApiRefEntityStatusGet(jwt, referralId) {
  return await referralAxiosGet(jwt, `Referrals/entityprogress/${referralId}`)
}

export async function refApiRefEntityStatusListPost(jwt, referralIds) {
  return await referralAxiosPost(
    jwt,
    "Referrals/entityprogress/list",
    referralIds
  )
}

export async function refApiRefEntityStatusPut(jwt, referralStatusObj) {
  return await referralAxiosPut(
    jwt,
    "Referrals/entityprogress",
    referralStatusObj
  )
}

export async function refApiRefEntityNotesListGet(jwt, referralId) {
  return await referralAxiosGet(jwt, `Referrals/${referralId}/notes`)
}

export async function refApiRefEntityLatestNoteGet(jwt, referralId) {
  return await referralAxiosGet(jwt, `Referrals/${referralId}/latestNote`)
}

export async function refApiRefEntityNotePut(jwt, referralId, referralNoteObj) {
  return await referralAxiosPut(
    jwt,
    `Referrals/${referralId}/note`,
    referralNoteObj
  )
}

export async function RefApiRefRatingGet(jwt, referralId) {
  return await referralAxiosGet(jwt, `Referrals/${referralId}/rating`)
}

export async function refApiRefEntityPerUserPost(jwt, uid, organzationId) {
  return await referralAxiosPost(jwt, `ReferralEntities/userallocations`, {
    userId: uid,
    entityOrganizationId: organzationId,
  })
}
